import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import {env} from 'config/env';

const {debug, fallbackLng, escapeValue} = env.i18n;

i18n
  .use(initReactI18next)
  .use(HttpApi)
  .use(LanguageDetector)
  .init({
    debug,
    fallbackLng,
    ns: ['error', 'ui'],
    defaultNS: 'common',
    fallbackNS: 'common',
    interpolation: {
      escapeValue,
    },
    supportedLngs: ['en', 'de'],
  });

export default i18n;
